export const INCIDENTS_MODEL = {
  TITLE: 'title',
  URL: 'http_url',
  PROVIER_ID: 'provider_id',
  STATUS: 'status',
  SOURCE: 'source',
  ISSUED_AT: 'issued_at',
  STARTED_AT: 'started_at',
  ENDED_AT: 'ended_at',
  REPOSITORIES: 'repositories',
  SERVICES: 'services',
  TEAMS: 'teams',
  SUMMARY: {
    INCIDENTS: 'summary.incidents_count'
  }
};

export const INCIDENTS_TABLE_MODEL = {
  INCIDENT_CELL: 'incident_cell',
  STATUS_CELL: 'status_cell',
  SOURCE_CELL: 'source_cell',
  ISSUED_AT_CELL: 'issued_at_cell',
  STARTED_AT_CELL: 'started_at_cell',
  ENDED_AT_CELL: 'ended_at_cell',
  REPOSITORIES_CELL: 'repositories_cell',
  SERVICES_CELL: 'services_cell',
  TEAMS_CELL: 'teams_cell'
};
